import createVideoPlayerRoute from "../create-video-player-route";

import FilmList from "../../../../views/digibord/content/season/FilmList.vue";

export default [
  {
    path: "film/:seasonSlug?/",
    name: "FilmList",
    component: FilmList,
    meta: {
      containerClass: "showVideoList",
    },
    children: [...createVideoPlayerRoute("FilmListVideoPlayer")],
  },
];
